module.exports = __webpack_public_path__ + "static/media/reversePyramidFilter_Active.39af68c8.svg";